export const T = {
  en_GB: {
    oneTime: "One-time",
    recurring: "Recurring",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
    amount: "Amount",
    date: "Date",
    start: "Start",
    end: "End",
    openEnded: "Open-ended",
    model: "Model",
    custom: "Custom",
  },
  nb_NO: {
    oneTime: "Engangs",
    recurring: "Gjentakende",
    monthly: "Månedlig",
    quarterly: "Kvartalsvis",
    yearly: "Årlig",
    amount: "Beløp",
    date: "Dato",
    start: "Start",
    end: "Slutt",
    openEnded: "Uten sluttdato",
    model: "Modell",
    custom: "Tilpasset",
  },
} as const;
